import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import OptionsDrawer from "../OptionsDrawer";

const MenuDrawer = (props) => {
  return (
    <div>
      {!props.user ? (
        <Typography>Realize o login</Typography>
      ) : (
        <OptionsDrawer {...props} />
      )}
    </div>
  );
};

export default MenuDrawer;
